import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Garage({ color = 'icon.primary', strokeWidth = '2', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 32 31' {...props}>
      <Path
        d='M10.9844 7.37915H16.6901'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M11.5738 14.9297H7.04297V25.5015'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.04183 25.5019H1.00079L1 6.84871C1 5.81258 1.56196 4.85796 2.46797
           4.35526L12.4531 1.33557C13.8319 0.581313 15.3415 1.33527 15.2244
            1.33557L25.208 4.35526C26.1132 4.8586 26.6744 5.81298 26.6744
             6.84871L26.6752 10.3993'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M31.2091 23.6885C31.2091 22.0203 29.8567 20.668 28.1885
           20.668H16.1065C14.4383 20.668 13.0859 22.0203 13.0859 23.6885'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.0859 23.6904V28.5233C13.0859 29.3574 13.7621 30.0335 14.5962
           30.0335H16.0914C16.9254 30.0335 17.6016 29.3574 17.6016
            28.5233V27.525H26.6934V28.5233C26.6934 29.3574 27.3696
             30.0335 28.2036 30.0335H29.6988C30.5329 30.0335 31.2091
              29.3574 31.2091 28.5233V23.6904'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M18.7242 24.1424H16.4648'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M27.8179 24.1424H25.5586'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M28.9492 20.5769L31.2086 19.448'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M15.3528 20.5742L13.0859 19.4453'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M18.4807 14.9298C17.4324 14.9325 16.5228 15.654 16.2817
           16.6742L15.3242 20.767L16.2817 16.6742C16.5228 15.654 17.4324
            14.9325 18.4807 14.9298H25.8266C26.8749 14.9325 27.7844 15.654
             28.0255 16.6742L28.983 20.767'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Garage.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default Garage
